import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'tf0042',
    ecrans: [
        '00-2',
        '01-2'
    ]
});
